// A special tag used for the contact us card

export function TopicButton({ topic, color }: { topic: string; color: string; }) {
    return (
        <div className={`${color} p-2 my-2 mx-2 rounded-md shadow-md`}>
            <h6>{topic}</h6>
        </div>
    );
}
